export default function () {
  const textareaResize = event => {
    event.target.style.height = "auto";
    event.target.style.height = `${event.target.scrollHeight + 2}px`; // +2 for borders
  };

  return {
    textareaResize,
  };
}
